import {Component, input, Input, signal} from '@angular/core';
import {
  MatDrawerContainer,
  MatDrawerContent,
  MatSidenav,
  MatSidenavContainer,
  MatSidenavContent
} from '@angular/material/sidenav';
import {MatListItem, MatNavList} from '@angular/material/list';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {MatIcon} from '@angular/material/icon';
import {AuthService} from '../../shared/services/auth';

@Component({
  selector: 'app-sidenav',
  imports: [
    MatSidenav,
    MatSidenavContainer,
    MatNavList,
    MatListItem,
    MatIcon,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './sidenav.html',
  styleUrl: './sidenav.css',
})
export class Sidenav {
  tabs = input<{
    name: string;
    icon: string;
    route: string;
    order: number;
    active: boolean;
  }[]>([]);

  constructor(private authService: AuthService,) {}

  logout() {
    this.authService.logout();
  }
}
